import { Ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMainStore } from '@/features/common/stores';
import { AppConfigDto } from '@/types/webapi';
import { useAppStore } from '@geta/kolumbus-frontend/features/common';

export const useAppConfiguration = (): { config: Ref<AppConfigDto>; language: Ref<string> } => {
    const appStore = useAppStore();
    const mainStore = useMainStore();
    const { language } = storeToRefs(appStore);
    const { config } = storeToRefs(mainStore);

    return { config, language };
};
